<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-title"><b>ACKNOWLEDGMENTS</b></p>
<p class="ded"><i>I’ve been creating my entire life and there are so many people who’ve taught me, inspired me, and cheered me on along the way. I create because of you. Thank you to all my friends and family who have contributed to my stitching life. I’ve learned from you. And a special thank-you to my students; you are the brightest spot in my stitching world.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0004_ack.vue?3c91db15